import { Button, Checkbox, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function Referral({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "referral";
  const sectionTitle =
    "Referral: Define or limit the referral sources for this product";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.referral;
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        sAllowOutsideCounselors: data?.sAllowOutsideCounselors || "NO",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {productModulesGroup?.includes("product-agency") && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="sAllowOutsideCounselors"
                control={control}
                render={({ field }) => (
                  <Checkbox
                    {...field}
                    size="small"
                    color="primary"
                    checked={field.value === "YES"}
                    onChange={(e) => {
                      field.onChange(e.target.checked ? "YES" : "NO");
                    }}
                  />
                )}
              />
              Allow referral from counselors outside of affiliated agencies
            </Grid>
          </Grid>
        )}
      </Box>
      {/* Form Actions */}
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          disabled={!isDirty}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
